import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class RebNgxLabelComponent {
    constructor() {
        /**
         * if is needed some color different that the mood colors, we could use "color" to use it over the mood Input colors
         */
        this.color = '';
        /**
         * font mood color
         */
        this.mood = 'default';
        /**
         * font size
         */
        this.size = '12';
        /**
         * font weight
         */
        this.weight = '400';
    }
    get classes() {
        return [
            `font ${this.color ? '' : `mood-text--${this.mood}`}
      font-size--${this.size}
      font-weight--${this.weight}`
        ];
    }
}
RebNgxLabelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxLabelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
RebNgxLabelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.10", type: RebNgxLabelComponent, selector: "reb-ngx-label", inputs: { color: "color", mood: "mood", size: "size", weight: "weight" }, ngImport: i0, template: "<label class=\"rn-label\" [ngClass]=\"classes\" [style.color]=\"color ? color : ''\">\n  <ng-content></ng-content>\n</label>\n", styles: [".rn-label.mood-text--default{color:var(--palette-dark-blue-0)}.rn-label.mood-text--none{color:var(--palette-grey-60)}\n"], directives: [{ type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxLabelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'reb-ngx-label', template: "<label class=\"rn-label\" [ngClass]=\"classes\" [style.color]=\"color ? color : ''\">\n  <ng-content></ng-content>\n</label>\n", styles: [".rn-label.mood-text--default{color:var(--palette-dark-blue-0)}.rn-label.mood-text--none{color:var(--palette-grey-60)}\n"] }]
        }], propDecorators: { color: [{
                type: Input
            }], mood: [{
                type: Input
            }], size: [{
                type: Input
            }], weight: [{
                type: Input
            }] } });

class RebNgxLabelModule {
}
RebNgxLabelModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxLabelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
RebNgxLabelModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxLabelModule, declarations: [RebNgxLabelComponent], imports: [CommonModule], exports: [RebNgxLabelComponent] });
RebNgxLabelModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxLabelModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxLabelModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [RebNgxLabelComponent],
                    imports: [CommonModule],
                    exports: [RebNgxLabelComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { RebNgxLabelComponent, RebNgxLabelModule };
